import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import classNames from "classnames";

import { selectNextAttempt } from "util/selectNextAttempt";
import {
  updateAttributeOnDocument,
  updateAttributesOnDocument,
} from "util/pouchActions";
import {
  getCurrentMeet,
  getKnownLiftingOrder,
  getCurrentAttempt,
  getCurrentLifter,
  getLeftRefDoc,
  getHeadRefDoc,
  getRightRefDoc,
  getCurrentPlatform,
} from "selectors";
import Lights from "components/lights/Lights";
import ThumbsDownIcon from "icons/ThumbsDownIcon";
import ThumbsUpIcon from "icons/ThumbsUpIcon";
import ClockIcon from "icons/ClockIcon";
import ResetIcon from "icons/ResetIcon";
import CheckIcon from "icons/CheckIcon";
import NextIcon from "icons/NextIcon";

import "./RefIndex.scss";

const startClock = function (platformId, meet) {
  updateAttributeOnDocument(meet._id, platformId, "clockState", "started");
};

const resetClock = function (platformId, meet) {
  updateAttributeOnDocument(meet._id, platformId, "clockState", "initial");
};

class RefIndex extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.position !== this.props.match.params.position ||
      prevProps.match.params.platformId !==
        this.props.match.params.platformId ||
      _.get(prevProps.meet, [
        "platforms",
        prevProps.match.params.platformId,
        "currentAttemptId",
      ]) !==
        _.get(this.props.meet, [
          "platforms",
          this.props.match.params.platformId,
          "currentAttemptId",
        ])
    ) {
      this.setState({
        red: false,
        blue: false,
        yellow: false,
      });
    }
  }

  getPositionDoc = () => {
    const { match, meet } = this.props;
    return _.get(
      meet,
      ["platforms", match.params.platformId, "refs", match.params.position],
      {}
    );
  };

  getIsBadLift = () => {
    return this.getPositionDoc().decision === "bad";
  };

  getIsGoodLift = () => {
    return this.getPositionDoc().decision === "good";
  };

  toggleCard = (card) => {
    const { meet } = this.props;
    const refDoc = this.getPositionDoc();
    const currentCardState = !_.get(refDoc, ["cards", card]);
    const changes = {
      cards: { ...refDoc.cards, [card]: currentCardState },
    };

    // if toggling a card and a white light is selected remove white light
    if (!currentCardState && _.get(refDoc, ["decision"])) {
    } else {
      changes.decision = null;
    }
    updateAttributesOnDocument(meet._id, refDoc._id, changes);
  };

  selectGoodLift = () => {
    this.confirmSelection("good");
  };

  selectBadLift = () => {
    this.confirmSelection("bad");
  };

  confirmSelection = (decision) => {
    const { meet } = this.props;
    const refDoc = this.getPositionDoc();

    if (refDoc.decision === decision) {
      // toggle off
      updateAttributeOnDocument(meet._id, refDoc._id, "decision", null);
    } else {
      const changes = {
        decision,
      };

      if (decision === "good") {
        changes.cards = {
          red: false,
          blue: false,
          yellow: false,
        };
      }

      updateAttributesOnDocument(meet._id, refDoc._id, changes);
    }
  };

  canConfirmLift = () => {
    const { leftRefDoc, headRefDoc, rightRefDoc } = this.props;
    return leftRefDoc.decision && headRefDoc.decision && rightRefDoc.decision;
  };

  willBeGoodLift = () => {
    const { leftRefDoc, headRefDoc, rightRefDoc } = this.props;

    return (
      (_.get(leftRefDoc, "decision") === "good" &&
        _.get(headRefDoc, "decision") === "good") ||
      (_.get(rightRefDoc, "decision") === "good" &&
        _.get(headRefDoc, "decision") === "good") ||
      (_.get(leftRefDoc, "decision") === "good" &&
        _.get(rightRefDoc, "decision") === "good")
    );
  };

  selectNextAttempt = (nextLiftingOrder) => {
    const { meet, platform, leftRefDoc, headRefDoc, rightRefDoc } = this.props;

    updateAttributesOnDocument(meet._id, leftRefDoc._id, {
      decision: null,
      cards: null,
    });
    updateAttributesOnDocument(meet._id, headRefDoc._id, {
      decision: null,
      cards: null,
    });
    updateAttributesOnDocument(meet._id, rightRefDoc._id, {
      decision: null,
      cards: null,
    });
    selectNextAttempt(nextLiftingOrder, meet, platform);
  };

  markAttempt = () => {
    const {
      meet,
      currentAttempt,
      leftRefDoc,
      headRefDoc,
      rightRefDoc,
      knownLiftingOrder,
    } = this.props;
    const result = this.willBeGoodLift() ? "good" : "bad";

    const changes = {
      result,
      decisions: {
        left: {
          decision: leftRefDoc.decision,
          cards: leftRefDoc.cards,
        },
        head: {
          decision: headRefDoc.decision,
          cards: headRefDoc.cards,
        },
        right: {
          decision: rightRefDoc.decision,
          cards: rightRefDoc.cards,
        },
      },
    };

    // allows the sytem to be used for lights only
    if (currentAttempt._id) {
      updateAttributesOnDocument(meet._id, currentAttempt._id, changes);
    }

    this.selectNextAttempt(knownLiftingOrder);
  };

  render() {
    const { match, meet, currentLifter, currentAttempt, platform } = this.props;
    const { platformId, position } = match.params;
    const refDoc = this.getPositionDoc();

    return (
      <div className="ref">
        <div className="position">{position} Referee</div>
        <div className="current">
          <div className="current-lifter">{_.get(currentLifter, "name")}</div>
          <div className="current-attempt">
            {_.get(currentAttempt, "liftName")}{" "}
            {_.get(currentAttempt, "attemptNumber")} -{" "}
            {_.get(currentAttempt, "weight", "000")}
            {meet.units}
          </div>
        </div>
        {position === "head" && (
          <div className="clock">
            <button
              disabled={platform.clockState === "started"}
              onClick={() => startClock(platformId, meet)}
            >
              <ClockIcon />
            </button>
            <button
              disabled={platform.clockState === "initial"}
              onClick={() => resetClock(platformId, meet)}
            >
              <ResetIcon />
            </button>
          </div>
        )}
        <div className="fault-cards">
          <button
            className="fault-card red"
            onClick={() => this.toggleCard("red")}
          >
            <div>RED</div>
            <div className="icon-wrapper">
              {_.get(refDoc, ["cards", "red"]) && <ThumbsDownIcon />}
            </div>
          </button>
          <button
            className="fault-card blue"
            onClick={() => this.toggleCard("blue")}
          >
            <div>BLUE</div>
            <div className="icon-wrapper">
              {_.get(refDoc, ["cards", "blue"]) && <ThumbsDownIcon />}
            </div>
          </button>
          <button
            className="fault-card yellow"
            onClick={() => this.toggleCard("yellow")}
          >
            <div>YELLOW</div>
            <div className="icon-wrapper">
              {_.get(refDoc, ["cards", "yellow"]) && <ThumbsDownIcon />}
            </div>
          </button>
        </div>
        <button
          className={classNames("bad", "button", {
            selected: this.getIsBadLift(),
          })}
          onClick={this.selectBadLift}
        >
          <div className="icon-wrapper">
            <ThumbsDownIcon />
          </div>
          <div className="check-icon-wrapper">
            {this.getIsBadLift() && <CheckIcon />}
          </div>
        </button>
        <div>
          <button
            className={classNames("good", "button", {
              selected: this.getIsGoodLift(),
            })}
            onClick={this.selectGoodLift}
          >
            <div className="icon-wrapper">
              <ThumbsUpIcon />
            </div>
            <div className="check-icon-wrapper">
              {this.getIsGoodLift() && <CheckIcon />}
            </div>
          </button>
        </div>
        {position === "head" && (
          <div>
            <button
              className="button record"
              disabled={!this.canConfirmLift()}
              onClick={this.markAttempt}
            >
              <div>
                RECORD
                {this.canConfirmLift() && (
                  <span>
                    {this.willBeGoodLift() && <span> GOOD LIFT </span>}
                    {!this.willBeGoodLift() && <span> NO LIFT </span>}
                  </span>
                )}
              </div>
              <div>
                {" "}
                AND SELECT NEXT LIFTER{" "}
                <span className="icon-wrapper">
                  <NextIcon />
                </span>
              </div>
            </button>
          </div>
        )}
        <Lights meet={meet} platformId={platformId} showChecks />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    knownLiftingOrder: getKnownLiftingOrder(state, props),
    currentAttempt: getCurrentAttempt(state, props),
    currentLifter: getCurrentLifter(state, props),
    leftRefDoc: getLeftRefDoc(state, props),
    headRefDoc: getHeadRefDoc(state, props),
    rightRefDoc: getRightRefDoc(state, props),
    platform: getCurrentPlatform(state, props),
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(RefIndex);
